import { render, staticRenderFns } from "./RoleManagementView.vue?vue&type=template&id=f2c0bb24&scoped=true"
import script from "./RoleManagementView.vue?vue&type=script&lang=js"
export * from "./RoleManagementView.vue?vue&type=script&lang=js"
import style0 from "./RoleManagementView.vue?vue&type=style&index=0&id=f2c0bb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c0bb24",
  null
  
)

export default component.exports